import Vue from 'vue'
import App from './App.vue'
import router from './router'

import '@vant/touch-emulator';
import Vant from 'vant';
// import 'vant/lib/index.css';
import '@/assets/wcc.css'


Vue.use(Vant);


import axios from 'axios'
import VueAxios from 'vue-axios'

axios.interceptors.response.use(function (response) {
  if(response.data.errcode!='suc')console.log("全局拦截",response.config.url);
  if(response.data.errcode=="need-phone"){
    console.log("需要绑定手机")
    if(window.JSInterface) {
      window.JSInterface.callMethod('bindPhone', null)
    }
    return Promise.reject('need-phone');
  }
  else{
    return response;
  }

}, function (error) {
  return Promise.reject(error);
});
Vue.use(VueAxios, axios);

var VueCookie = require('vue-cookie');
Vue.use(VueCookie);

var moment = require('moment');
moment.locale('zh-cn');
Vue.prototype.moment = moment;

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
